import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=46c40dc8"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c40dc8')) {
      api.createRecord('46c40dc8', component.options)
    } else {
      api.reload('46c40dc8', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=46c40dc8", function () {
      api.rerender('46c40dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/Account.vue"
export default component.exports